import { useLocation } from 'react-router-dom';
import { useAuthContext } from '../../contexts/authContext';
import { useMemo } from 'react';
import Sidebar from './Sidebar';

interface Props {
  children: React.ReactNode;
}

const Layout = ({ children }: Props) => {
  const { isAuthenticated, user } = useAuthContext();

  const location = useLocation();

  const shouldHideSidebar = useMemo(() => {
    return [
      '/login',
      '/register',
      '/home',
      '/about',
      '/login/forgot-password',
    ].includes(location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen">
      {!shouldHideSidebar && isAuthenticated && user && <Sidebar user={user} />}
      <div className="w-full">
        {children}
      </div>
    </div>
  );
};

export default Layout;
